import React, { useEffect } from "react";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import Avicon from "../images/ClotaHDLogoRound.png"; // Avatar image

const WhatsApp = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      const button = document.querySelector(".floating-whatsapp-button");
      if (button) button.click(); // Auto-open after 1 sec (optional)
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Inline CSS for positioning */}
      <style>
        {`
          .floating-whatsapp-button {
            bottom: 90px !important;
            right: 20px !important;
            z-index: 9999 !important;
          }
        `}
      </style>

      <FloatingWhatsApp
        phoneNumber="+91 9490384177"
        accountName="Need Help"
        allowEsc
        allowClickAway
        notification
        notificationSound
        chatMessage="Hi there! 👋 How can we help you today?"
        statusMessage="Typically replies within a few minutes"
        avatar={Avicon}
      />
    </>
  );
};

export default WhatsApp;
